// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3rt-W","description":"PatientConsentPreview_description__1zGM7"};